import ResidentBioTemplate from "app/features/residents/templates/view/ResidentBioTemplate";

export default function ResidentBioScreen() {
  return <ResidentBioTemplate />;
}
